import type { InfoBannerProps } from '/site/parts/info-banner/info-banner.d';

import { faBell as faProLightBell } from '@fortawesome/pro-light-svg-icons';
import { faBell as faProRegularBell } from '@fortawesome/pro-regular-svg-icons';
import { Link } from '@hdir/ui/link';
import React from 'react';

import { FontAwesomeIconWrapper } from '/react4xp/components/FontAwesomeIconWrapper';
import { ODF_LOGO_ALT_TEXT } from '/react4xp/overdosefare/constants';


const ICONS = {
	faProLightBell: faProLightBell,
	faProRegularBell: faProRegularBell,
} as const;


export function InfoBanner(props: InfoBannerProps): JSX.Element {
	const {
		title,
		text,
		logo,
		linkHref,
		linkLabel,
		linkIcon,
	} = props;

	return (
		<section className="py-xl tablet:py-[96px]">
			<div className="flex justify-between items-center gap-xl">
				<div className="flex max-w-[600px] flex-col gap-md tablet:gap-lg">
					<h2 className="text-xxl tablet:text-[36px] font-bold leading-normal">{title}</h2>
					<p className="text-md tablet:text-xl leading-normal max-w-text">{text}</p>
					{
						linkHref && linkLabel
							? <Link
								href={linkHref}
								size='large'
								variant="button-primary"
							>
								{
									linkIcon
										? <FontAwesomeIconWrapper fixedWidth={true} icon={ICONS[linkIcon]} />
										: null
								}
								{linkLabel}
							</Link>
							: null
					}
				</div>
				{logo && (
					<img
						alt={ODF_LOGO_ALT_TEXT}
						className="hidden tablet:block h-[200px] w-auto mr-xxl"
						src={logo}
					/>
				)}
			</div>
		</section>
	);
}
